import { render, staticRenderFns } from "./tokenizer.vue?vue&type=template&id=e20f967c&scoped=true"
import script from "./tokenizer.vue?vue&type=script&lang=js"
export * from "./tokenizer.vue?vue&type=script&lang=js"
import style0 from "./tokenizer.vue?vue&type=style&index=0&id=e20f967c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20f967c",
  null
  
)

export default component.exports